dialog {
  display: block;

  border: 1px solid #dfdfdf;
  border-radius: var(--border-radius);

  padding: var(--Paddings-lg);
  background: var(--background);

  max-width: 32rem;
  width: calc(100vw - 2 * var(--Paddings-lg));
  max-height: 90vh;
  overflow: auto;

  box-shadow:
    0 287px 80px 0 rgba(0, 0, 0, 0),
    0 183px 73px 0 rgba(0, 0, 0, 0.01),
    0 103px 62px 0 rgba(0, 0, 0, 0.05),
    0 46px 46px 0 rgba(0, 0, 0, 0.09),
    0 11px 25px 0 rgba(0, 0, 0, 0.1);
  outline: none;
}

dialog::backdrop {
  background-color: rgba(0, 0, 0, 0.6);
}

@media (max-width: 480px) {
  dialog {
    padding: var(--Paddings-sm);
  }
}

/* preview mode */
dialog[data-preview] {
  position: relative;
  inset: 0;
  margin: auto;
  width: auto;
  max-width: auto;
  max-height: auto;
  border: none;
  overflow: hidden;
}
